// `obj` is optional because callers pass a query bag that may not be there — `useApi`'s
// `customQuery` and `useSocket`'s `params`. `for…in` over `undefined` simply yields nothing.
function getSearchQueryFromObject(obj?: Record<string, any>) {
  let result = "";

  for (let key in obj) {
    const value = obj[key];

    if (value || value === 0) {
      result += `&${key}=${encodeURIComponent(
        value === Object(value) ? JSON.stringify(value) : value
      )}`;
    }
  }

  result = result.replace("&", "?");

  return result;
}

export default getSearchQueryFromObject;
